import { IProductFilter, IProductFilterOption } from '../../constants/product/productFilter.constant';

interface IChangeProductFilterOptionIsSelectedParams {
  currentFilters: IProductFilter[];
  targetFilter: IProductFilter;
  targetOption: IProductFilterOption;
}

export const changeProductFilterOptionIsSelected = ({
  currentFilters,
  targetFilter,
  targetOption,
}: IChangeProductFilterOptionIsSelectedParams): IProductFilter[] => {
  // 변경할 옵션이 라디오 타입인 경우
  if (targetFilter.optionType === 'radio') {
    const newProductFilters = currentFilters.map((filter) => {
      if (filter.key === targetFilter.key) {
        // 기존에 선택된 옵션 값 삭제
        const removeSelectedOptions = filter.options.map((option) => {
          option.isSelected = false;
          return option;
        });

        // 변경할 옵션 값 추가
        const newOptions = removeSelectedOptions.map((option) => {
          if (option.value === targetOption.value) {
            option.isSelected = true;
          }
          return option;
        });
        return { ...filter, options: newOptions };
      }

      return filter;
    });

    return newProductFilters;
  }

  // 변경할 옵션이 체크박스 타입인 경우
  if (targetFilter.optionType === 'checkbox') {
    const newProductFilters = currentFilters.map((filter) => {
      if (filter.key === targetFilter.key) {
        // 옵션 값 변경 (true <-> false)
        const newOptions = filter.options.map((option) => {
          if (option.value === targetOption.value) {
            option.isSelected = !option.isSelected;
          }
          return option;
        });
        return { ...filter, options: newOptions };
      }

      return filter;
    });

    return newProductFilters;
  }

  return [];
};
